
import { Component, Vue } from 'nuxt-property-decorator'
import meta from '@/helpers/meta'
import Form from '@/helpers/validation/form'
import LavoraConValidator from '@/helpers/validation/lavora-con-noi'

@Component
export default class LavoraConNoiPage extends LavoraConValidator {
  public form: Form = new Form('Lavora con noi', 'Lavora con noi')

  public head() {
    return meta(
      'Lavora Con Noi',
      'Associazione astagiudiziaria.com',
      this.$config.siteUrl + 'img/logo.png',
      this.$config.siteUrl + 'lavora-con-noi'
    )
  }

  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e)
    }
  }

  public async onSubmit() {
    // @ts-ignore
    this.$v.$touch()
    // @ts-ignore
    if (this.$v.$invalid) {
      return false
    }

    const postData = { ...this.form }
    delete postData.privacy
    postData.recaptcha = await this.$recaptcha.execute('lavoraconnoi')

    try {
      await this.$axios.post('messaggi', postData)

      // eslint-disable-next-line no-undef
      _iub.cons_instructions.push([
        'submit',
        {
          submitElement: document.getElementById('contact-submit'),
          form: {
            selector: document.getElementById('contact-form'),
            map: {
              subject: {
                full_name: 'name',
                email: 'email',
              },
              preferences: { legal_documents: 'privacy' },
            },
          },
          consent: {
            legal_notices: [{ identifier: 'privacy_policy' }],
          },
        },
        {
          error(err: any) {
            console.error(err)
          },
          success(response: any) {
            console.log(response)
          },
        },
      ])
    } catch (error: any) {
      if (error?.response?.status === 422) {
        this.setErrors(error.response.data.errors)
        return
      }
      throw error
    }

    this.form = new Form('Lavora con noi', 'Lavora con noi')
    this.success = true
    setTimeout(() => {
      this.$v.$reset()
    }, 100)
  }

  public beforeDestroy() {
    this.$recaptcha.destroy()
  }

  // messaggi
}
